import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Button, SegmentLoader } from '@si-armes/dsfr-react';
import { connect } from 'react-redux';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import { FormProvider, useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import BoutonFichierTelechargeable from '../../../../../components/Commun/Fichier/BoutonFichierTelechargeable';
import InputFiles from '../../../../../components/Commun/Form/InputFiles';
import ReglesImport from './reglesImport';
import getDateTimeNowWithUnderscores from '../../../../../utils/dateUtils';
import usagerClientReducer from '../../../../../store/usagerReducer';
import {
    CONTEXT_AJOUT_ARME_EN_MASSE_FICHIERS_IMPORTES,
    CONTEXT_AJOUT_ARME_EN_MASSE_IMPORT,
    CONTEXT_AJOUT_ARME_EN_MASSE_MODELE_INTERNATIONAL,
    CONTEXT_AJOUT_ARME_EN_MASSE_MODELE_NATIONAL,
    GET_FICHIERS_TRAITEMENT_EN_MASSE_URL,
    GET_MODELE_TRAITEMENT_EN_MASSE_INTERNATIONAL,
    GET_MODELE_TRAITEMENT_EN_MASSE_NATIONAL,
    MODELE_FICHIER_AJOUT_ARMES_INTERNATIONAL_NAME,
    MODELE_FICHIER_AJOUT_ARMES_NATIONAL_NAME,
    TRAITEMENT_EN_MASSE_URL,
} from '../../../../../constants/apiUrls.constants';
import { MIME_TEXT_CSV } from '../../../../../constants/fileConstant';
import { TYPE_PIECE_JOINTE_AJOUT_ARME_EN_MASSE } from '../../../../../constants/ajoutArmeEnMasse.constants';

const ImporterArme = ({
    modeleNational,
    modeleInternational,
    getApi,
    postApi,
    numSia,
    isLoading,
    fichierImporte,
}) => {
    const hookForm = useForm({
        mode: 'onChange',
    });
    const [fichierImport, setFichierImport] = useState(null);

    const [importDesactive, setImportDesactive] = useState(true);

    const { watch, handleSubmit } = hookForm;
    const file = watch('import');

    const customFileNamingFuntion = () => {
        return `SIA_${numSia}_${fichierImport?.filename}_${getDateTimeNowWithUnderscores()}`;
    };

    const formaterFichier = async () => {
        const contenuFichier = await fichierImport.getFileToSend();

        return {
            contenu: contenuFichier.contenu,
            libelle: customFileNamingFuntion(),
            typePieceJointe: { ...TYPE_PIECE_JOINTE_AJOUT_ARME_EN_MASSE },
        };
    };

    useEffect(() => {
        if (file && file.length > 0) {
            const uploadedFile = file[0];
            setFichierImport(uploadedFile);
            setImportDesactive(false);
        } else {
            setImportDesactive(true);
        }
    }, [file]);

    useEffect(() => {
        if (fichierImporte && !isLoading) {
            getApi(
                usagerClientReducer,
                GET_FICHIERS_TRAITEMENT_EN_MASSE_URL,
                CONTEXT_AJOUT_ARME_EN_MASSE_FICHIERS_IMPORTES,
            );
        }
    }, [fichierImporte, isLoading]);

    const onSubmit = async () => {
        const send = await formaterFichier();
        postApi(
            usagerClientReducer,
            TRAITEMENT_EN_MASSE_URL,
            send,
            CONTEXT_AJOUT_ARME_EN_MASSE_IMPORT,
        );
    };

    const telechargerModeleNational = () => {
        getApi(
            usagerClientReducer,
            GET_MODELE_TRAITEMENT_EN_MASSE_NATIONAL,
            CONTEXT_AJOUT_ARME_EN_MASSE_MODELE_NATIONAL,
        );
    };

    const telechargerModeleInternational = () => {
        getApi(
            usagerClientReducer,
            GET_MODELE_TRAITEMENT_EN_MASSE_INTERNATIONAL,
            CONTEXT_AJOUT_ARME_EN_MASSE_MODELE_INTERNATIONAL,
        );
    };

    return (
        <SegmentLoader isLoading={isLoading}>
            <Container>
                <Row className="margin-bottom-sm">
                    <Col col={6}>
                        <Container>
                            <Row className="margin-bottom-sm">
                                <BoutonFichierTelechargeable
                                    style={{ width: '100%' }}
                                    titreFichier={MODELE_FICHIER_AJOUT_ARMES_NATIONAL_NAME}
                                    mimeType={MIME_TEXT_CSV}
                                    iconOnly
                                    label="Télécharger le modèle de fichier pour les armes nationales"
                                    handleOnClick={telechargerModeleNational}
                                    contenu={modeleNational?.contenu}
                                />
                            </Row>

                            <Row>
                                <BoutonFichierTelechargeable
                                    style={{ width: '100%' }}
                                    titreFichier={MODELE_FICHIER_AJOUT_ARMES_INTERNATIONAL_NAME}
                                    mimeType={MIME_TEXT_CSV}
                                    iconOnly
                                    label="Télécharger le modèle de fichier pour les armes internationales"
                                    handleOnClick={telechargerModeleInternational}
                                    contenu={modeleInternational?.contenu}
                                />
                            </Row>
                        </Container>
                    </Col>
                    <Col col={6}>
                        <Container>
                            <Row style={{ justifyContent: 'center' }}>
                                Cliquez pour importer le modèle de fichier complété :
                            </Row>
                            <FormProvider {...hookForm}>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Row
                                        className="margin-bottom-sm"
                                        style={{ justifyContent: 'center', textAlign: 'center' }}
                                    >
                                        <InputFiles
                                            name="import"
                                            nombreMaxFichiers={1}
                                            multiple={false}
                                            accept=".csv"
                                            texteAide="La taille maximale autorisée de votre document est de 5Mo"
                                        />
                                    </Row>
                                    <Row style={{ justifyContent: 'center' }}>
                                        <Button type="submit" disabled={importDesactive}>
                                            Envoyer
                                        </Button>
                                    </Row>
                                </form>
                            </FormProvider>
                        </Container>
                    </Col>
                </Row>
                <ReglesImport />
            </Container>
        </SegmentLoader>
    );
};

ImporterArme.propTypes = {
    numSia: PropTypes.string.isRequired,
    postApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    armes: PropTypes.array,
    fichierImporte: PropTypes.object,
    isLoading: PropTypes.bool,
    modeleNational: PropTypes.object,
    modeleInternational: PropTypes.object,
};

export default connect(
    (state) => {
        const { data: modeleNational } = state.armes.ajoutArmeEnMasse.modeleNational;
        const { data: modeleInternational } = state.armes.ajoutArmeEnMasse.modeleInternational;
        const { data: fichierImporte, isLoading } = state.armes.ajoutArmeEnMasse.import;

        return {
            fichierImporte,
            isLoading,
            modeleNational,
            modeleInternational,
        };
    },
    {
        postApi: postAPI,
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(ImporterArme);
